'use client';

import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { Background } from './components/Background';
import { DescriptionSection } from './components/DescriptionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { GamesSection } from './components/GamesSection';
import { HowToWinSection } from './components/HowToWinSection';
import { JackpotMessage } from './components/JackpotMessage';
import { JackpotSection } from './components/JackpotSection';
import { TermsSection } from './components/TermsSection';
import { WinnersTable } from './components/WinnersTable';
import GeneralSkeleton from '@/components/skeletons/GeneralSkeleton';
import { groupMemberJackpotUsers } from '@/helpers/user';
import { useCommonStore } from '@/store';

import { ScJackpotPage } from './styled';
import { ScContainer } from '@/styles/common';

export default function JackpotPage() {
  const { pendingJackpots, user } = useCommonStore(
    useShallow((state) => ({
      pendingJackpots: state.pendingJackpots,
      user: state.user,
    }))
  );

  const isMessage = useMemo(
    () => !!user && !groupMemberJackpotUsers(user),
    [user]
  );

  if (pendingJackpots) return <GeneralSkeleton />;

  return (
    <ScJackpotPage>
      <Background withMessage={isMessage} />

      <ScContainer>
        {isMessage && <JackpotMessage />}
        <JackpotSection />

        <div className="page-content">
          <DescriptionSection />
          <FeaturesSection />
          <GamesSection />
          <HowToWinSection />
          <WinnersTable />
          <TermsSection />
        </div>
      </ScContainer>
    </ScJackpotPage>
  );
}
